// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__22j0F","file":"styles_file__1FMay"};